import React, { Component } from 'react';

export class Grid extends Component {
  render() {
    const { gap = '1rem', min = '8rem', max = '1fr' } = this.props;
    const styles = {
      display: 'grid',
      gridGap: gap,
      gridTemplateColumns: `repeat(auto-fill,minmax(${min},${max}))`,
    }
    return (
      <div style={styles}>
        {this.props.children}
      </div>
    );
  }
}

export default Grid;
